import $ from 'jquery'
const object = vnObject

const input = $('.js-blog-search-input')
input
  .autocomplete({
    minLength: 3,
    appendTo: input.parent().find('.js-blog-search-results'),
    source: function (request, response) {
      $.ajax({
        url: object.ajaxUrl,
        type: 'POST',
        dataType: 'JSON',
        data: {
          _ajax_nonce: object.nonce,
          action: 'vn_get_posts',
          keyword: request.term,
          postType: 'post',
        },
        success: function (res) {
          response(res.data.data)
        },
      })
    },
    search: function (event) {
      $(event.target)
        .parents('.js-blog-search')
        .addClass('js-blog-search--searching')
    },
    open: function (event) {
      $(event.target)
        .parents('.js-blog-search')
        .addClass('js-blog-search--active')
      $(event.target).addClass('autocomplete-active')
    },
    close: function (event) {
      $(event.target)
        .parents('.js-blog-search')
        .removeClass('js-blog-search--active')
      $(event.target).removeClass('autocomplete-active')
    },
    response: function (event) {
      $(event.target)
        .parents('.js-blog-search')
        .removeClass('js-blog-search--searching')
    },
    create: function () {
      $(this).data('ui-autocomplete')._renderItem = function (ul, item) {
        return $('<li>')
          .append(
            `<a href="${item.url}" data-id="${item.id}" class="ajax-post${
              !item.success ? ' ajax-post--error' : ''
            }">${
              item.thumbnail
                ? `<img src="${item.thumbnail}" alt="${item.name}">`
                : ''
            }
            ${
              item.icon ? `${item.icon}` : ''
            }<div><span class="ajax-post__title">${item.title}</span></div></a>`
          )
          .appendTo(ul)
      }
    },
  })
  .focus(function () {
    $(this).data('uiAutocomplete').search($(this).val())
  })

jQuery.ui.autocomplete.prototype._resizeMenu = function () {
  var ul = this.menu.element
  ul.outerWidth(this.element.outerWidth())
}

$('.js-blog-select').on('change', function () {
  const val = $(this).val()
  window.location.href = val
})
